import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function SideBar(props) {
	const { public_id } = props;
	const location = useLocation();

	function setSectionLinkToActive(sectionUrl) {
		if (location.pathname.indexOf(sectionUrl) > -1) {
			return 'mm-active';
		}
	}

	function setLinkToActive(pathname) {
		if (location.pathname === pathname) {
			return 'mm-active';
		}
	}

	function displaySectionLink(hasPermission, path, icon, label) {
		if (!hasPermission) {
			return null;
		}

		if (hasPermission) {
			return (
				<Link
					to={path}
					className={setSectionLinkToActive(path) + ' waves-effect'}
				>
					<i className={icon} />
					{label}
				</Link>
			);
		}
	}

	function displayLink(hasFFGPermission, path, label) {
		if (hasFFGPermission) {
			return (
				<Link to={path} className={setLinkToActive(path)}>
					{label}
				</Link>
			);
		}
	}

	return (
		<div className="sidebar">
			<div className="vertical-menu">
				<div data-simplebar className="h-100">
					<div id="sidebar-menu">
						<ul className="metismenu list-unstyled">
							<li className="menu-title">{I18n.t('admin.menu')}</li>

							{/* Display the link if the user has the show reports permission */}
							{props.permissionsHelper.hasShowReportsPermissions() && (
								<li>
									<Link
										to={`/admin/${public_id}/reports/org-stats`}
										className={
											setSectionLinkToActive(`/admin/${public_id}/reports/`) +
											' waves-effect'
										}
									>
										<i className="ri-bar-chart-line" />
										{I18n.t('admin.reports')}
									</Link>
									<ul
										className="sub-menu mm-collapse mm-show"
										aria-expanded="false"
									>
										<li>
											<Link
												to={`/admin/${public_id}/reports/org-stats`}
												className={setLinkToActive(
													`/admin/${public_id}/reports/org-stats`
												)}
											>
												{I18n.t('admin.org_stats')}
											</Link>
										</li>
										<li>
											<Link
												to={`/admin/${public_id}/reports/user-progress`}
												className={setLinkToActive(
													`/admin/${public_id}/reports/user-progress`
												)}
											>
												{I18n.t('admin.user_progress')}
											</Link>
										</li>
										<li>
											<Link
												to={`/admin/${public_id}/reports/learning-data`}
												className={setLinkToActive(
													`/admin/${props.public_id}/reports/learning-data`
												)}
											>
												{I18n.t('admin.learning_data')}
											</Link>
										</li>
										<li>
											<Link
												to={`/admin/${public_id}/reports/assessment-data`}
												className={setLinkToActive(
													`/admin/${public_id}/reports/assessment-data`
												)}
											>
												{I18n.t('admin.assessment_data')}
											</Link>
										</li>
										<li>
											<Link
												to={`/admin/${public_id}/reports/popular-courses`}
												className={setLinkToActive(
													`/admin/${public_id}/reports/popular-courses`
												)}
											>
												{I18n.t('admin.popular_courses')}
											</Link>
										</li>
									</ul>
								</li>
							)}

							{/* Display the link if the user has the show users permission */}
							{props.permissionsHelper.hasShowUsersPermissions() && (
								<li>
									<Link
										to={`/admin/${public_id}/users/`}
										className={
											setSectionLinkToActive(`/admin/${public_id}/users/`) +
											' waves-effect'
										}
									>
										<i className="fa fa-users" />
										{I18n.t('admin.users')}
									</Link>
									<ul
										className="sub-menu mm-collapse mm-show"
										aria-expanded="false"
									>
										{props.permissionsHelper.isOnlyProctor() ? null : (
											<li>
												<Link
													to={`/admin/${public_id}/groups`}
													className={setLinkToActive(
														`/admin/${public_id}/groups`
													)}
												>
													{I18n.t('admin.groups')}
												</Link>
											</li>
										)}
									</ul>
								</li>
							)}
							<li>
								{displaySectionLink(
									props.permissionsHelper.hasCreateAccountPermissions(),
									`/admin/${public_id}/accounts`,
									`fa fa-briefcase`,
									I18n.t('admin.accounts')
								)}
							</li>

							{/*<li>
								{displaySectionLink(
									props.permissionsHelper.hasCreateLearningPlanPermissions(),
									props.endpoints.new_learning_plan_endpoint,
									`fa fa-graduation-cap`,
									I18n.t('admin.learning_plans')
								)}
							</li>*/}
							<li>
								{displaySectionLink(
									props.permissionsHelper.hasActionTriggerPermissions(),
									`/admin/${public_id}/learning-plans`,
									`fa fa-graduation-cap`,
									I18n.t('admin.learning_plans')
								)}
							</li>
							<li>
								{displaySectionLink(
									props.permissionsHelper.hasActionTriggerPermissions(),
									`/admin/${public_id}/action-triggers`,
									`fa fa-bullhorn`,
									I18n.t('admin.action_triggers')
								)}
							</li>
							{/*<li>
                <Link
                  to={`/admin/${public_id}/assessments`}
                  className={
                    setSectionLinkToActive(`/admin/${public_id}/assessments`) +
                    " waves-effect"
                  }
                >
                  <i className="fa fa-list-ul" />
                  {I18n.t("admin.assessments")}
                </Link>
                </li>*/}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}
